var map = {
	"./hombre/cuerpo-hombre-piel-amarilla.png": 1252,
	"./hombre/cuerpo-hombre-piel-clara.png": 1253,
	"./hombre/cuerpo-hombre-piel-oscura.png": 1254,
	"./mujer/cuerpo-mujer-piel-amarilla.png": 1255,
	"./mujer/cuerpo-mujer-piel-clara.png": 1256,
	"./mujer/cuerpo-mujer-piel-oscura.png": 1257
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1251;